import { Box, Typography, Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import React from 'react';
import { FadedPaper } from '../../theme/StyledFields';

interface Props {
    organizationName: string;
    reportDate: string;
    submissionCount: number;
}

const TeamReportHeader: React.FC<Props> = ({ organizationName, reportDate, submissionCount }) => (
    <FadedPaper sx={{ p: 3, mb: 3 }} data-testid="report-header">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                    Team Assessment Report
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {organizationName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Report Date: {reportDate} &bull; {submissionCount} submissions analyzed
                </Typography>
            </Box>
            <Button
                variant="outlined"
                startIcon={<PrintIcon />}
                onClick={() => window.print()}
                className="no-print"
            >
                Print
            </Button>
        </Box>
    </FadedPaper>
);

export default TeamReportHeader;
